import { render, staticRenderFns } from "./v-tabs.vue?vue&type=template&id=1ed11e72"
import script from "./v-tabs.vue?vue&type=script&lang=js"
export * from "./v-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports